export const callDispo = [
  "Account Opened",
  "Funds/Margin",
  "Language Barrier",
  "Not Connected",
  "Not Eligible",
  "Not Interested",
  "Rejected",
  "WIP",
  "Connected"
];

export const callSubDispo = [
  {
    name: "Ringing",
    notconnected: true,
    accountopened: false,
    notinterested: false,
    wip: false,
    rejected: false,
    noteligible: false,
    languagebarrier: false,
    fundsmargin: false,
  },
  {
    name: "Busy",
    notconnected: true,
    accountopened: false,
    notinterested: false,
    wip: false,
    rejected: false,
    noteligible: false,
    languagebarrier: false,
    fundsmargin: false,
  },
  {
    name: "Switch Off",
    notconnected: true,
    accountopened: false,
    notinterested: false,
    wip: false,
    rejected: false,
    noteligible: false,
    languagebarrier: false,
    fundsmargin: false,
  },
  {
    name: "Call Disconnected",
    notconnected: false,
    accountopened: false,
    notinterested: false,
    wip: false,
    rejected: false,
    noteligible: false,
    languagebarrier: false,
    fundsmargin: false,
  },
  {
    name: "Not Reachable",
    notconnected: true,
    accountopened: false,
    notinterested: false,
    wip: false,
    rejected: false,
    noteligible: false,
    languagebarrier: false,
    fundsmargin: false,
  },
  {
    name: "Incoming Not-Available",
    notconnected: true,
    accountopened: false,
    notinterested: false,
    wip: false,
    rejected: false,
    noteligible: false,
    languagebarrier: false,
    fundsmargin: false,
  },
  {
    name: "Voice-Message",
    notconnected: true,
    accountopened: false,
    notinterested: false,
    wip: false,
    rejected: false,
    noteligible: false,
    languagebarrier: false,
    fundsmargin: false,
  },
  {
    name: "Short Hungup",
    notconnected: false,
    accountopened: false,
    notinterested: false,
    wip: false,
    rejected: false,
    noteligible: false,
    languagebarrier: false,
    fundsmargin: false,
    connected: true,
  },
  {
    name: "E-Sign Done",
    notconnected: false,
    accountopened: true,
    notinterested: false,
    wip: false,
    rejected: false,
    noteligible: false,
    languagebarrier: false,
    fundsmargin: false,
  },
  {
    name: "Payment Done",
    notconnected: false,
    accountopened: false,
    notinterested: false,
    wip: false,
    rejected: false,
    noteligible: false,
    languagebarrier: false,
    fundsmargin: false,
  },
  {
    name: "KYC Rejected",
    notconnected: false,
    accountopened: true,
    notinterested: false,
    wip: false,
    rejected: false,
    noteligible: false,
    languagebarrier: false,
    fundsmargin: false,
  },
  {
    name: "Referral Pitched",
    notconnected: false,
    accountopened: true,
    notinterested: false,
    wip: false,
    rejected: false,
    noteligible: false,
    languagebarrier: false,
    fundsmargin: false,
  },
  {
    name: "Wrong Registration-Sites",
    notconnected: false,
    accountopened: false,
    notinterested: true,
    wip: false,
    rejected: false,
    noteligible: false,
    languagebarrier: false,
    fundsmargin: false,
  },
  {
    name: "No Knowledge of stock broking",
    notconnected: false,
    accountopened: false,
    notinterested: true,
    wip: false,
    rejected: false,
    noteligible: false,
    languagebarrier: false,
    fundsmargin: false,
  },
  {
    name: "Registration Done for Enquiry",
    notconnected: false,
    accountopened: false,
    notinterested: true,
    wip: false,
    rejected: false,
    noteligible: false,
    languagebarrier: false,
    fundsmargin: false,
  },
  {
    name: "Lost to Competitor",
    notconnected: false,
    accountopened: false,
    notinterested: false,
    wip: false,
    rejected: false,
    noteligible: true,
    languagebarrier: false,
    fundsmargin: false,
  },
  {
    name: "Reason Not Provided",
    notconnected: false,
    accountopened: false,
    notinterested: true,
    wip: false,
    rejected: false,
    noteligible: false,
    languagebarrier: false,
    fundsmargin: false,
  },
  {
    name: "Registered By Mistake",
    notconnected: false,
    accountopened: false,
    notinterested: true,
    wip: false,
    rejected: false,
    noteligible: false,
    languagebarrier: false,
    fundsmargin: false,
  },
  {
    name: "Looking For Loan",
    notconnected: false,
    accountopened: false,
    notinterested: true,
    wip: false,
    rejected: false,
    noteligible: false,
    languagebarrier: false,
    fundsmargin: false,
  },
  {
    name: "Looking For Job",
    notconnected: false,
    accountopened: false,
    notinterested: true,
    wip: false,
    rejected: false,
    noteligible: false,
    languagebarrier: false,
    fundsmargin: false,
  },
  {
    name: "Looking For Shopping",
    notconnected: false,
    accountopened: false,
    notinterested: true,
    wip: false,
    rejected: false,
    noteligible: false,
    languagebarrier: false,
    fundsmargin: false,
  },
    {
    name: "Looking For Coupon",
    notconnected: false,
    accountopened: false,
    notinterested: true,
    wip: false,
    rejected: false,
    noteligible: false,
    languagebarrier: false,
    fundsmargin: false,
  },
  {
    name: "Without Presentation",
    notconnected: false,
    accountopened: false,
    notinterested: false,
    wip: false,
    rejected: false,
    noteligible: false,
    languagebarrier: false,
    fundsmargin: false,
  },
  {
    name: "With Presentation",
    notconnected: false,
    accountopened: false,
    notinterested: false,
    wip: false,
    rejected: false,
    noteligible: false,
    languagebarrier: false,
    fundsmargin: false,
  },
  {
    name: "Follow-Up/Product Pitched",
    notconnected: false,
    accountopened: false,
    notinterested: false,
    wip: true,
    rejected: false,
    noteligible: false,
    languagebarrier: false,
    fundsmargin: false,
  },
  {
    name: "Scheduled Callback",
    notconnected: false,
    accountopened: false,
    notinterested: false,
    wip: true,
    rejected: false,
    noteligible: false,
    languagebarrier: false,
    fundsmargin: false,
  },
  {
    name: "Call Back no time given",
    notconnected: false,
    accountopened: false,
    notinterested: false,
    wip: true,
    rejected: false,
    noteligible: false,
    languagebarrier: false,
    fundsmargin: false,
  },
  {
    name: "Wrong Number",
    notconnected: false,
    accountopened: false,
    notinterested: false,
    wip: false,
    rejected: true,
    noteligible: false,
    languagebarrier: false,
    fundsmargin: false,
  },
  {
    name: "Inappropriate/Abusive",
    notconnected: false,
    accountopened: false,
    notinterested: false,
    wip: false,
    rejected: true,
    noteligible: false,
    languagebarrier: false,
    fundsmargin: false,
  },
  {
    name: "DND",
    notconnected: false,
    accountopened: false,
    notinterested: false,
    wip: false,
    rejected: true,
    noteligible: false,
    languagebarrier: false,
    fundsmargin: false,
  },
  {
    name: "Registered to another Number",
    notconnected: false,
    accountopened: false,
    notinterested: false,
    wip: false,
    rejected: false,
    noteligible: false,
    languagebarrier: false,
    fundsmargin: false,
  },
  {
    name: "Documents Unavailable",
    notconnected: false,
    accountopened: false,
    notinterested: false,
    wip: false,
    rejected: false,
    noteligible: true,
    languagebarrier: false,
    fundsmargin: false,
  },
  {
    name: "NRI/Minor/HUF/Partnership Account/Students",
    notconnected: false,
    accountopened: false,
    notinterested: false,
    wip: false,
    rejected: false,
    noteligible: false,
    languagebarrier: false,
    fundsmargin: false,
  },
  {
    name: "Products Unavailable",
    notconnected: false,
    accountopened: false,
    notinterested: false,
    wip: false,
    rejected: false,
    noteligible: false,
    languagebarrier: false,
    fundsmargin: false,
  },
  {
    name: "Existing Customer",
    notconnected: false,
    accountopened: false,
    notinterested: false,
    wip: false,
    rejected: false,
    noteligible: true,
    languagebarrier: false,
    fundsmargin: false,
  },
  {
    name: "Out Of India",
    notconnected: false,
    accountopened: false,
    notinterested: false,
    wip: false,
    rejected: false,
    noteligible: true,
    languagebarrier: false,
    fundsmargin: false,
  },
  {
    name: "NRI/ Minor/ HUF/ Partnership Account/ Students",
    notconnected: false,
    accountopened: false,
    notinterested: false,
    wip: false,
    rejected: false,
    noteligible: true,
    languagebarrier: false,
    fundsmargin: false,
  },
  {
    name: "Test Lead",
    notconnected: false,
    accountopened: false,
    notinterested: false,
    wip: false,
    rejected: false,
    noteligible: true,
    languagebarrier: false,
    fundsmargin: false,
  },
  {
    name: "Sebi Rejected",
    notconnected: false,
    accountopened: false,
    notinterested: false,
    wip: false,
    rejected: false,
    noteligible: true,
    languagebarrier: false,
    fundsmargin: false,
  },
  {
    name: "Tamil",
    notconnected: false,
    accountopened: false,
    notinterested: false,
    wip: false,
    rejected: false,
    noteligible: false,
    languagebarrier: true,
    fundsmargin: false,
  },
  {
    name: "Telugu",
    notconnected: false,
    accountopened: false,
    notinterested: false,
    wip: false,
    rejected: false,
    noteligible: false,
    languagebarrier: true,
    fundsmargin: false,
  },
  {
    name: "Kannada",
    notconnected: false,
    accountopened: false,
    notinterested: false,
    wip: false,
    rejected: false,
    noteligible: false,
    languagebarrier: true,
    fundsmargin: false,
  },
  {
    name: "Malyalam",
    notconnected: false,
    accountopened: false,
    notinterested: false,
    wip: false,
    rejected: false,
    noteligible: false,
    languagebarrier: true,
    fundsmargin: false,
  },
  {
    name: "Bengali/Orrisa",
    notconnected: false,
    accountopened: false,
    notinterested: false,
    wip: false,
    rejected: false,
    noteligible: false,
    languagebarrier: true,
    fundsmargin: false,
  },
  {
    name: "Gujrati",
    notconnected: false,
    accountopened: false,
    notinterested: false,
    wip: false,
    rejected: false,
    noteligible: false,
    languagebarrier: true,
    fundsmargin: false,
  },
  {
    name: "Others",
    notconnected: false,
    accountopened: false,
    notinterested: false,
    wip: false,
    rejected: false,
    noteligible: false,
    languagebarrier: true,
    fundsmargin: false,
  },
  {
    name: "Added",
    notconnected: false,
    accountopened: false,
    notinterested: false,
    wip: false,
    rejected: false,
    noteligible: false,
    languagebarrier: false,
    fundsmargin: true,
  },
  {
    name: "Not Added",
    notconnected: false,
    accountopened: false,
    notinterested: false,
    wip: false,
    rejected: false,
    noteligible: false,
    languagebarrier: false,
    fundsmargin: true,
  },
  {
    name: "Will Add Later",
    notconnected: false,
    accountopened: false,
    notinterested: false,
    wip: false,
    rejected: false,
    noteligible: false,
    languagebarrier: false,
    fundsmargin: true,
  },
  {
    name: "Not Interested",
    notconnected: false,
    accountopened: false,
    notinterested: false,
    wip: false,
    rejected: false,
    noteligible: false,
    languagebarrier: false,
    fundsmargin: false,
  },
];

export const leadPriorityOptions = ["High", "Low"];
